import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

interface EpicHeaderPillsProps {
  className?: string
}

const EpicHeaderPills: React.FC<EpicHeaderPillsProps> = ({ className = '' }) => {
  const location = useLocation()
  const navigate = useNavigate()

  // Determine active tab based on current route
  const getActiveTab = (): 'analysis' | 'reports' => {
    if (location.pathname === '/epics/analysis') {
      return 'reports'
    }
    // Default to analysis for /epics and any other epic routes
    return 'analysis'
  }

  const activeTab = getActiveTab()

  const handleTabClick = (tab: 'analysis' | 'reports') => {
    if (tab === 'analysis') {
      navigate('/epics')
    } else {
      navigate('/epics/analysis')
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent, tab: 'analysis' | 'reports') => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleTabClick(tab)
    }
  }

  const tabs = [
    { id: 'analysis', label: 'Analysis' },
    { id: 'reports', label: 'Reports' }
  ] as const

  return (
    <div className={`epic-header-pills ${className}`}>
      <div className="bg-gray-100 rounded-full p-1 shadow-inner">
        <div className="flex space-x-1">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id

            return (
              <button
                key={tab.id}
                role="tab"
                aria-selected={isActive}
                tabIndex={isActive ? 0 : -1}
                className={`
                  px-4 py-2 rounded-full text-sm font-medium transition-all duration-200
                  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                  ${isActive
                    ? 'bg-blue-500 text-white shadow-sm'
                    : 'text-gray-600 hover:text-gray-800 hover:bg-gray-200'
                  }
                `}
                onClick={() => handleTabClick(tab.id)}
                onKeyDown={(e) => handleKeyDown(e, tab.id)}
              >
                {tab.label}
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default EpicHeaderPills